import PRIVILEGE from "./privilege";
import LOCALE_FILENAME from "./localeFilename";

const CONSTANTS = {
  BRANCH: {
    SELECTED_BRANCH: "selected-branch",
  },
  PRIVILEGE,
  EVENT_NAME: {
    CLICK: "click",
  },
  LOCALE_FILENAME,
  DATE_TIME_FORMAT: {
    YYYY_MM_DD_SLASH: "YYYY/MM/DD",
  },
};

export default CONSTANTS;
